import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TermsAndConditions from "../pages/termsandcondition";
import ThankYou from "../pages/thankyou";
import GiftThankYou from "../pages/giftThankYou";
import Privacy from "../pages/privacy";
import Redirect from "../pages/redirect";
import PaymentCancel from "../pages/paymentcancelled";
import CheckInService from "../pages/checkinservice";
import SpecialEvents from "../pages/specialevents";
import Redeem from "../pages/gift/Redeem";
import GiftPay from "../pages/gift/GiftPay";
import GiftPayResult from "../pages/gift/GiftPayResult";
import GiftDecision from "../pages/gift/GiftDecision";
import { useSelector } from "react-redux";
import LanguageSwitcher from "../components/languageSwitcher";
import GiftProfileView from "../pages/gift/GiftProfileView";

const CommonRoute = () => {
  const auth = useSelector((state) => state.auth);
  // Admin stays in English, so no dropdown for admin.
  const showLanguageSwitcher = auth.role !== "admin";
  return (
    <>
    {showLanguageSwitcher && (
      <div className="auth-language-switcher">
        <LanguageSwitcher />
      </div>
    )}
    <Routes>
      <Route path="/" element={<Navigate to="/terms-conditions" />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/special-events" element={<SpecialEvents />} />
     <Route path="/starter-volunteer-onboarding" element={<Redirect />} />
     <Route path="/thank-you-page" element={<ThankYou />} />
     <Route path="/gift-thank-you" element={<GiftThankYou />} />
     <Route path="/payment-cancelled" element={<PaymentCancel />} />
     {/* VerySoul Gift — public: recipient redeem flow and purchaser pay page */}
     <Route path="/redeem" element={<Redeem />} />
     <Route path="/gift-pay/complete" element={<GiftPayResult result="complete" />} />
     <Route path="/gift-pay/cancelled" element={<GiftPayResult result="cancelled" />} />
     <Route path="/gift-pay/:token" element={<GiftPay />} />
     <Route path="/gift-decision/:token" element={<GiftDecision />} />
     <Route path="/profile-view/:id" element={<GiftProfileView />} />
   
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    </>
  );
};
export default CommonRoute;
